/* tslint:disable */
/* eslint-disable */
/**
 * OnData.Deployment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AlertAndTime
 */
export interface AlertAndTime {
    /**
     * 
     * @type {string}
     * @memberof AlertAndTime
     */
    'alert'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertAndTime
     */
    'isWarning'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AlertAndTime
     */
    'alertTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AlertAndTime
     */
    'deploymentId'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertAndTime
     */
    'parameters'?: Array<string> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum CloudProvider {
    Azure = 1,
    AzureUSGovernment = 2,
    Aws = 3,
    Gcp = 4
}

/**
 * 
 * @export
 * @interface CreateNetworkConnectionInput
 */
export interface CreateNetworkConnectionInput {
    /**
     * 
     * @type {string}
     * @memberof CreateNetworkConnectionInput
     */
    'name': string;
    /**
     * 
     * @type {NetworkConnectionType}
     * @memberof CreateNetworkConnectionInput
     */
    'type'?: NetworkConnectionType;
    /**
     * 
     * @type {number}
     * @memberof CreateNetworkConnectionInput
     */
    'gatewayId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateNetworkConnectionInput
     */
    'localPublicIp': string;
    /**
     * 
     * @type {string}
     * @memberof CreateNetworkConnectionInput
     */
    'sharedKey': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateNetworkConnectionInput
     */
    'localAddressSpaces': Array<string>;
}
/**
 * 
 * @export
 * @interface CreateNetworkGatewayInput
 */
export interface CreateNetworkGatewayInput {
    /**
     * 
     * @type {string}
     * @memberof CreateNetworkGatewayInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateNetworkGatewayInput
     */
    'performanceTier': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum CustomizedOption {
    Good = 0,
    Better = 1,
    Best = 2
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum DatabaseType {
    MySQL = 1,
    PostgreSQL = 2,
    SQLServer = 3,
    MongoDB = 4,
    MariaDB = 5,
    Oracle = 6
}

/**
 * 
 * @export
 * @interface DeleteAfterBackupInput
 */
export interface DeleteAfterBackupInput {
    /**
     * 
     * @type {number}
     * @memberof DeleteAfterBackupInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeleteAfterBackupInput
     */
    'backupId'?: number;
}
/**
 * 
 * @export
 * @interface DeploymentDashboardResponseDto
 */
export interface DeploymentDashboardResponseDto {
    /**
     * 
     * @type {number}
     * @memberof DeploymentDashboardResponseDto
     */
    'deploymentSuccessCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeploymentDashboardResponseDto
     */
    'deploymentWarningCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeploymentDashboardResponseDto
     */
    'deploymentFailedCount'?: number;
    /**
     * 
     * @type {Array<AlertAndTime>}
     * @memberof DeploymentDashboardResponseDto
     */
    'deploymentAlerts'?: Array<AlertAndTime> | null;
}
/**
 * 
 * @export
 * @interface DeploymentResponseDto
 */
export interface DeploymentResponseDto {
    /**
     * 
     * @type {number}
     * @memberof DeploymentResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeploymentResponseDto
     */
    'deploymentId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeploymentResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {DatabaseType}
     * @memberof DeploymentResponseDto
     */
    'databaseType'?: DatabaseType;
    /**
     * 
     * @type {string}
     * @memberof DeploymentResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DeploymentResponseDto
     */
    'engineId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeploymentResponseDto
     */
    'engineVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeploymentResponseDto
     */
    'engineEdition'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DeploymentResponseDto
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeploymentResponseDto
     */
    'sizeText'?: string | null;
    /**
     * 
     * @type {CloudProvider}
     * @memberof DeploymentResponseDto
     */
    'cloudPlatform'?: CloudProvider;
    /**
     * 
     * @type {string}
     * @memberof DeploymentResponseDto
     */
    'region'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DeploymentResponseDto
     */
    'fromDatabaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeploymentResponseDto
     */
    'fromBackupId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DeploymentResponseDto
     */
    'fromEncryptionId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeploymentResponseDto
     */
    'isWindows'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DeploymentResponseDto
     */
    'osName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeploymentResponseDto
     */
    'vmSize'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeploymentResponseDto
     */
    'vmName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeploymentResponseDto
     */
    'hostingSpecification'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeploymentResponseDto
     */
    'privateIp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeploymentResponseDto
     */
    'username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeploymentResponseDto
     */
    'password'?: string | null;
    /**
     * 
     * @type {DeploymentStatus}
     * @memberof DeploymentResponseDto
     */
    'deploymentStatus'?: DeploymentStatus;
    /**
     * 
     * @type {string}
     * @memberof DeploymentResponseDto
     */
    'deploymentAlert'?: string | null;
    /**
     * 
     * @type {InstanceStatus}
     * @memberof DeploymentResponseDto
     */
    'status'?: InstanceStatus;
    /**
     * 
     * @type {string}
     * @memberof DeploymentResponseDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeploymentResponseDto
     */
    'isProduction'?: boolean;
    /**
     * 
     * @type {CustomizedOption}
     * @memberof DeploymentResponseDto
     */
    'customizedOption'?: CustomizedOption;
    /**
     * 
     * @type {string}
     * @memberof DeploymentResponseDto
     */
    'validationCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeploymentResponseDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeploymentResponseDto
     */
    'deployedTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeploymentResponseDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DeploymentResponseDto
     */
    'connectionString'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum DeploymentStatus {
    InProgress = 0,
    Success = 1,
    Warning = 2,
    Failed = 3,
    Deleting = 4,
    Stopping = 5,
    Stopped = 6,
    Restarting = 7
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum DiskType {
    HDD = 0,
    StandardSSD = 1,
    PremiumSSD = 2
}

/**
 * 
 * @export
 * @interface GetFilesWithUriInput
 */
export interface GetFilesWithUriInput {
    /**
     * 
     * @type {number}
     * @memberof GetFilesWithUriInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetFilesWithUriInput
     */
    'backupId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetFilesWithUriInput
     */
    'encryptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetFilesWithUriInput
     */
    'deploymentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetFilesWithUriInput
     */
    'publicKeyXml': string;
    /**
     * 
     * @type {string}
     * @memberof GetFilesWithUriInput
     */
    'validationCode': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum InstanceStatus {
    Offline = 0,
    Online = 1
}

/**
 * 
 * @export
 * @interface MutateDeploymentStateInput
 */
export interface MutateDeploymentStateInput {
    /**
     * 
     * @type {number}
     * @memberof MutateDeploymentStateInput
     */
    'deploymentId': number;
    /**
     * 
     * @type {string}
     * @memberof MutateDeploymentStateInput
     */
    'action'?: string | null;
}
/**
 * 
 * @export
 * @interface NetworkConnectionResponseDto
 */
export interface NetworkConnectionResponseDto {
    /**
     * 
     * @type {number}
     * @memberof NetworkConnectionResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetworkConnectionResponseDto
     */
    'networkConnectionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetworkConnectionResponseDto
     */
    'networkGatewayId'?: number;
    /**
     * 
     * @type {string}
     * @memberof NetworkConnectionResponseDto
     */
    'networkGatewayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NetworkConnectionResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {NetworkConnectionType}
     * @memberof NetworkConnectionResponseDto
     */
    'type'?: NetworkConnectionType;
    /**
     * 
     * @type {string}
     * @memberof NetworkConnectionResponseDto
     */
    'typeText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NetworkConnectionResponseDto
     */
    'localPublicIp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NetworkConnectionResponseDto
     */
    'sharedKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NetworkConnectionResponseDto
     */
    'localAddressSpaces'?: string | null;
    /**
     * 
     * @type {NetworkConnectionStatus}
     * @memberof NetworkConnectionResponseDto
     */
    'status'?: NetworkConnectionStatus;
    /**
     * 
     * @type {string}
     * @memberof NetworkConnectionResponseDto
     */
    'statusText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NetworkConnectionResponseDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NetworkConnectionResponseDto
     */
    'isDeleted'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum NetworkConnectionStatus {
    InProgress = 0,
    Success = 1,
    Failed = 2,
    Updating = 3
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum NetworkConnectionType {
    SiteToSite = 0
}

/**
 * 
 * @export
 * @interface NetworkGatewayResponseDto
 */
export interface NetworkGatewayResponseDto {
    /**
     * 
     * @type {number}
     * @memberof NetworkGatewayResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof NetworkGatewayResponseDto
     */
    'networkGatewayId'?: number;
    /**
     * 
     * @type {string}
     * @memberof NetworkGatewayResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NetworkGatewayResponseDto
     */
    'performanceTier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NetworkGatewayResponseDto
     */
    'onDataPublicIp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NetworkGatewayResponseDto
     */
    'onDataAddressSpace'?: string | null;
    /**
     * 
     * @type {NetworkGatewayStatus}
     * @memberof NetworkGatewayResponseDto
     */
    'status'?: NetworkGatewayStatus;
    /**
     * 
     * @type {string}
     * @memberof NetworkGatewayResponseDto
     */
    'statusText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NetworkGatewayResponseDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NetworkGatewayResponseDto
     */
    'isDeleted'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum NetworkGatewayStatus {
    InProgress = 0,
    Success = 1,
    Failed = 2,
    Updating = 3,
    Deleting = 4
}

/**
 * 
 * @export
 * @interface NewDeploymentInput
 */
export interface NewDeploymentInput {
    /**
     * 
     * @type {number}
     * @memberof NewDeploymentInput
     */
    'databaseId': number;
    /**
     * 
     * @type {number}
     * @memberof NewDeploymentInput
     */
    'backupId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NewDeploymentInput
     */
    'encryptionId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof NewDeploymentInput
     */
    'isProduction'?: boolean;
    /**
     * 
     * @type {CustomizedOption}
     * @memberof NewDeploymentInput
     */
    'customizedOption'?: CustomizedOption;
    /**
     * 
     * @type {string}
     * @memberof NewDeploymentInput
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof NewDeploymentInput
     */
    'password': string;
    /**
     * 
     * @type {boolean}
     * @memberof NewDeploymentInput
     */
    'ifMigrate'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NewDeploymentInput
     */
    'databaseName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NewDeploymentInput
     */
    'ifCloneMappings'?: boolean;
}
/**
 * 
 * @export
 * @interface ReportDatabaseStatusInput
 */
export interface ReportDatabaseStatusInput {
    /**
     * 
     * @type {number}
     * @memberof ReportDatabaseStatusInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {InstanceStatus}
     * @memberof ReportDatabaseStatusInput
     */
    'status'?: InstanceStatus;
}
/**
 * 
 * @export
 * @interface ReportResultInput
 */
export interface ReportResultInput {
    /**
     * 
     * @type {number}
     * @memberof ReportResultInput
     */
    'deploymentId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReportResultInput
     */
    'isSuccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReportResultInput
     */
    'log'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportResultInput
     */
    'exception'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportResultInput
     */
    'validationCode'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateNetworkConnectionInput
 */
export interface UpdateNetworkConnectionInput {
    /**
     * 
     * @type {number}
     * @memberof UpdateNetworkConnectionInput
     */
    'networkConnectionId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateNetworkConnectionInput
     */
    'localPublicIp': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNetworkConnectionInput
     */
    'sharedKey': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateNetworkConnectionInput
     */
    'localAddressSpaces': Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateNetworkGatewayInput
 */
export interface UpdateNetworkGatewayInput {
    /**
     * 
     * @type {number}
     * @memberof UpdateNetworkGatewayInput
     */
    'networkGatewayId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateNetworkGatewayInput
     */
    'performanceTier': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum UsageScenario {
    Validation = 0,
    Encryption = 1,
    Deployment = 2
}

/**
 * 
 * @export
 * @interface VmSkuResponseDto
 */
export interface VmSkuResponseDto {
    /**
     * 
     * @type {number}
     * @memberof VmSkuResponseDto
     */
    'engineId'?: number;
    /**
     * 
     * @type {UsageScenario}
     * @memberof VmSkuResponseDto
     */
    'usageScenario'?: UsageScenario;
    /**
     * 
     * @type {CustomizedOption}
     * @memberof VmSkuResponseDto
     */
    'customizedOption'?: CustomizedOption;
    /**
     * 
     * @type {boolean}
     * @memberof VmSkuResponseDto
     */
    'isProduction'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VmSkuResponseDto
     */
    'vcpus'?: number;
    /**
     * 
     * @type {number}
     * @memberof VmSkuResponseDto
     */
    'ram'?: number;
    /**
     * 
     * @type {CloudProvider}
     * @memberof VmSkuResponseDto
     */
    'cloudPlatform'?: CloudProvider;
    /**
     * 
     * @type {string}
     * @memberof VmSkuResponseDto
     */
    'vmSize'?: string | null;
    /**
     * 
     * @type {DiskType}
     * @memberof VmSkuResponseDto
     */
    'diskType'?: DiskType;
    /**
     * 
     * @type {number}
     * @memberof VmSkuResponseDto
     */
    'estimatePrice'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof VmSkuResponseDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VmSkuResponseDto
     */
    'diskSize'?: string | null;
}

/**
 * DeploymentsApi - axios parameter creator
 * @export
 */
export const DeploymentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentsDashboardGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployments/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} deploymentId 
         * @param {boolean} [ifBackup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentsDeploymentIdDelete: async (deploymentId: number, ifBackup?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deploymentId' is not null or undefined
            assertParamExists('apiDeploymentsDeploymentIdDelete', 'deploymentId', deploymentId)
            const localVarPath = `/api/deployments/{deploymentId}`
                .replace(`{${"deploymentId"}}`, encodeURIComponent(String(deploymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ifBackup !== undefined) {
                localVarQueryParameter['ifBackup'] = ifBackup;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} deploymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentsDeploymentIdGet: async (deploymentId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deploymentId' is not null or undefined
            assertParamExists('apiDeploymentsDeploymentIdGet', 'deploymentId', deploymentId)
            const localVarPath = `/api/deployments/{deploymentId}`
                .replace(`{${"deploymentId"}}`, encodeURIComponent(String(deploymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [backupId] 
         * @param {number} [encryptionId] 
         * @param {CustomizedOption} [customizedOption] 
         * @param {boolean} [isProduction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentsHostoptionsGet: async (databaseId?: number, backupId?: number, encryptionId?: number, customizedOption?: CustomizedOption, isProduction?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployments/hostoptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }

            if (backupId !== undefined) {
                localVarQueryParameter['backupId'] = backupId;
            }

            if (encryptionId !== undefined) {
                localVarQueryParameter['encryptionId'] = encryptionId;
            }

            if (customizedOption !== undefined) {
                localVarQueryParameter['customizedOption'] = customizedOption;
            }

            if (isProduction !== undefined) {
                localVarQueryParameter['isProduction'] = isProduction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NewDeploymentInput} [newDeploymentInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentsPost: async (newDeploymentInput?: NewDeploymentInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newDeploymentInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentsRandomkeyGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployments/randomkey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MutateDeploymentStateInput} [mutateDeploymentStateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentsStartPut: async (mutateDeploymentStateInput?: MutateDeploymentStateInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployments/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mutateDeploymentStateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MutateDeploymentStateInput} [mutateDeploymentStateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentsStopPut: async (mutateDeploymentStateInput?: MutateDeploymentStateInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployments/stop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mutateDeploymentStateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeploymentsApi - functional programming interface
 * @export
 */
export const DeploymentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeploymentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentsDashboardGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeploymentDashboardResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentsDashboardGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} deploymentId 
         * @param {boolean} [ifBackup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentsDeploymentIdDelete(deploymentId: number, ifBackup?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentsDeploymentIdDelete(deploymentId, ifBackup, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} deploymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentsDeploymentIdGet(deploymentId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeploymentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentsDeploymentIdGet(deploymentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeploymentResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [backupId] 
         * @param {number} [encryptionId] 
         * @param {CustomizedOption} [customizedOption] 
         * @param {boolean} [isProduction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentsHostoptionsGet(databaseId?: number, backupId?: number, encryptionId?: number, customizedOption?: CustomizedOption, isProduction?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VmSkuResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentsHostoptionsGet(databaseId, backupId, encryptionId, customizedOption, isProduction, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {NewDeploymentInput} [newDeploymentInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentsPost(newDeploymentInput?: NewDeploymentInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentsPost(newDeploymentInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentsRandomkeyGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentsRandomkeyGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {MutateDeploymentStateInput} [mutateDeploymentStateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentsStartPut(mutateDeploymentStateInput?: MutateDeploymentStateInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentsStartPut(mutateDeploymentStateInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {MutateDeploymentStateInput} [mutateDeploymentStateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentsStopPut(mutateDeploymentStateInput?: MutateDeploymentStateInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentsStopPut(mutateDeploymentStateInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DeploymentsApi - factory interface
 * @export
 */
export const DeploymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeploymentsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentsDashboardGet(options?: any): AxiosPromise<DeploymentDashboardResponseDto> {
            return localVarFp.apiDeploymentsDashboardGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} deploymentId 
         * @param {boolean} [ifBackup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentsDeploymentIdDelete(deploymentId: number, ifBackup?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.apiDeploymentsDeploymentIdDelete(deploymentId, ifBackup, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} deploymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentsDeploymentIdGet(deploymentId: number, options?: any): AxiosPromise<DeploymentResponseDto> {
            return localVarFp.apiDeploymentsDeploymentIdGet(deploymentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentsGet(options?: any): AxiosPromise<Array<DeploymentResponseDto>> {
            return localVarFp.apiDeploymentsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [backupId] 
         * @param {number} [encryptionId] 
         * @param {CustomizedOption} [customizedOption] 
         * @param {boolean} [isProduction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentsHostoptionsGet(databaseId?: number, backupId?: number, encryptionId?: number, customizedOption?: CustomizedOption, isProduction?: boolean, options?: any): AxiosPromise<Array<VmSkuResponseDto>> {
            return localVarFp.apiDeploymentsHostoptionsGet(databaseId, backupId, encryptionId, customizedOption, isProduction, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NewDeploymentInput} [newDeploymentInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentsPost(newDeploymentInput?: NewDeploymentInput, options?: any): AxiosPromise<number> {
            return localVarFp.apiDeploymentsPost(newDeploymentInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentsRandomkeyGet(options?: any): AxiosPromise<string> {
            return localVarFp.apiDeploymentsRandomkeyGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MutateDeploymentStateInput} [mutateDeploymentStateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentsStartPut(mutateDeploymentStateInput?: MutateDeploymentStateInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiDeploymentsStartPut(mutateDeploymentStateInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MutateDeploymentStateInput} [mutateDeploymentStateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentsStopPut(mutateDeploymentStateInput?: MutateDeploymentStateInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiDeploymentsStopPut(mutateDeploymentStateInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeploymentsApi - object-oriented interface
 * @export
 * @class DeploymentsApi
 * @extends {BaseAPI}
 */
export class DeploymentsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeploymentsApi
     */
    public apiDeploymentsDashboardGet(options?: AxiosRequestConfig) {
        return DeploymentsApiFp(this.configuration).apiDeploymentsDashboardGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} deploymentId 
     * @param {boolean} [ifBackup] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeploymentsApi
     */
    public apiDeploymentsDeploymentIdDelete(deploymentId: number, ifBackup?: boolean, options?: AxiosRequestConfig) {
        return DeploymentsApiFp(this.configuration).apiDeploymentsDeploymentIdDelete(deploymentId, ifBackup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} deploymentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeploymentsApi
     */
    public apiDeploymentsDeploymentIdGet(deploymentId: number, options?: AxiosRequestConfig) {
        return DeploymentsApiFp(this.configuration).apiDeploymentsDeploymentIdGet(deploymentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeploymentsApi
     */
    public apiDeploymentsGet(options?: AxiosRequestConfig) {
        return DeploymentsApiFp(this.configuration).apiDeploymentsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {number} [backupId] 
     * @param {number} [encryptionId] 
     * @param {CustomizedOption} [customizedOption] 
     * @param {boolean} [isProduction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeploymentsApi
     */
    public apiDeploymentsHostoptionsGet(databaseId?: number, backupId?: number, encryptionId?: number, customizedOption?: CustomizedOption, isProduction?: boolean, options?: AxiosRequestConfig) {
        return DeploymentsApiFp(this.configuration).apiDeploymentsHostoptionsGet(databaseId, backupId, encryptionId, customizedOption, isProduction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NewDeploymentInput} [newDeploymentInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeploymentsApi
     */
    public apiDeploymentsPost(newDeploymentInput?: NewDeploymentInput, options?: AxiosRequestConfig) {
        return DeploymentsApiFp(this.configuration).apiDeploymentsPost(newDeploymentInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeploymentsApi
     */
    public apiDeploymentsRandomkeyGet(options?: AxiosRequestConfig) {
        return DeploymentsApiFp(this.configuration).apiDeploymentsRandomkeyGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MutateDeploymentStateInput} [mutateDeploymentStateInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeploymentsApi
     */
    public apiDeploymentsStartPut(mutateDeploymentStateInput?: MutateDeploymentStateInput, options?: AxiosRequestConfig) {
        return DeploymentsApiFp(this.configuration).apiDeploymentsStartPut(mutateDeploymentStateInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MutateDeploymentStateInput} [mutateDeploymentStateInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeploymentsApi
     */
    public apiDeploymentsStopPut(mutateDeploymentStateInput?: MutateDeploymentStateInput, options?: AxiosRequestConfig) {
        return DeploymentsApiFp(this.configuration).apiDeploymentsStopPut(mutateDeploymentStateInput, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NetworkConnectionsApi - axios parameter creator
 * @export
 */
export const NetworkConnectionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNetworkconnectionsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/networkconnections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} networkConnectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNetworkconnectionsNetworkConnectionIdDelete: async (networkConnectionId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'networkConnectionId' is not null or undefined
            assertParamExists('apiNetworkconnectionsNetworkConnectionIdDelete', 'networkConnectionId', networkConnectionId)
            const localVarPath = `/api/networkconnections/{networkConnectionId}`
                .replace(`{${"networkConnectionId"}}`, encodeURIComponent(String(networkConnectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} networkConnectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNetworkconnectionsNetworkConnectionIdGet: async (networkConnectionId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'networkConnectionId' is not null or undefined
            assertParamExists('apiNetworkconnectionsNetworkConnectionIdGet', 'networkConnectionId', networkConnectionId)
            const localVarPath = `/api/networkconnections/{networkConnectionId}`
                .replace(`{${"networkConnectionId"}}`, encodeURIComponent(String(networkConnectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} networkConnectionId 
         * @param {UpdateNetworkConnectionInput} [updateNetworkConnectionInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNetworkconnectionsNetworkConnectionIdPut: async (networkConnectionId: number, updateNetworkConnectionInput?: UpdateNetworkConnectionInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'networkConnectionId' is not null or undefined
            assertParamExists('apiNetworkconnectionsNetworkConnectionIdPut', 'networkConnectionId', networkConnectionId)
            const localVarPath = `/api/networkconnections/{networkConnectionId}`
                .replace(`{${"networkConnectionId"}}`, encodeURIComponent(String(networkConnectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNetworkConnectionInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateNetworkConnectionInput} [createNetworkConnectionInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNetworkconnectionsPost: async (createNetworkConnectionInput?: CreateNetworkConnectionInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/networkconnections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNetworkConnectionInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NetworkConnectionsApi - functional programming interface
 * @export
 */
export const NetworkConnectionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NetworkConnectionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNetworkconnectionsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NetworkConnectionResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNetworkconnectionsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} networkConnectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNetworkconnectionsNetworkConnectionIdDelete(networkConnectionId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNetworkconnectionsNetworkConnectionIdDelete(networkConnectionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} networkConnectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNetworkconnectionsNetworkConnectionIdGet(networkConnectionId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NetworkConnectionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNetworkconnectionsNetworkConnectionIdGet(networkConnectionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} networkConnectionId 
         * @param {UpdateNetworkConnectionInput} [updateNetworkConnectionInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNetworkconnectionsNetworkConnectionIdPut(networkConnectionId: number, updateNetworkConnectionInput?: UpdateNetworkConnectionInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNetworkconnectionsNetworkConnectionIdPut(networkConnectionId, updateNetworkConnectionInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateNetworkConnectionInput} [createNetworkConnectionInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNetworkconnectionsPost(createNetworkConnectionInput?: CreateNetworkConnectionInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNetworkconnectionsPost(createNetworkConnectionInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NetworkConnectionsApi - factory interface
 * @export
 */
export const NetworkConnectionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NetworkConnectionsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNetworkconnectionsGet(options?: any): AxiosPromise<Array<NetworkConnectionResponseDto>> {
            return localVarFp.apiNetworkconnectionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} networkConnectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNetworkconnectionsNetworkConnectionIdDelete(networkConnectionId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiNetworkconnectionsNetworkConnectionIdDelete(networkConnectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} networkConnectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNetworkconnectionsNetworkConnectionIdGet(networkConnectionId: number, options?: any): AxiosPromise<NetworkConnectionResponseDto> {
            return localVarFp.apiNetworkconnectionsNetworkConnectionIdGet(networkConnectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} networkConnectionId 
         * @param {UpdateNetworkConnectionInput} [updateNetworkConnectionInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNetworkconnectionsNetworkConnectionIdPut(networkConnectionId: number, updateNetworkConnectionInput?: UpdateNetworkConnectionInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiNetworkconnectionsNetworkConnectionIdPut(networkConnectionId, updateNetworkConnectionInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateNetworkConnectionInput} [createNetworkConnectionInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNetworkconnectionsPost(createNetworkConnectionInput?: CreateNetworkConnectionInput, options?: any): AxiosPromise<number> {
            return localVarFp.apiNetworkconnectionsPost(createNetworkConnectionInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NetworkConnectionsApi - object-oriented interface
 * @export
 * @class NetworkConnectionsApi
 * @extends {BaseAPI}
 */
export class NetworkConnectionsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkConnectionsApi
     */
    public apiNetworkconnectionsGet(options?: AxiosRequestConfig) {
        return NetworkConnectionsApiFp(this.configuration).apiNetworkconnectionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} networkConnectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkConnectionsApi
     */
    public apiNetworkconnectionsNetworkConnectionIdDelete(networkConnectionId: number, options?: AxiosRequestConfig) {
        return NetworkConnectionsApiFp(this.configuration).apiNetworkconnectionsNetworkConnectionIdDelete(networkConnectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} networkConnectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkConnectionsApi
     */
    public apiNetworkconnectionsNetworkConnectionIdGet(networkConnectionId: number, options?: AxiosRequestConfig) {
        return NetworkConnectionsApiFp(this.configuration).apiNetworkconnectionsNetworkConnectionIdGet(networkConnectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} networkConnectionId 
     * @param {UpdateNetworkConnectionInput} [updateNetworkConnectionInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkConnectionsApi
     */
    public apiNetworkconnectionsNetworkConnectionIdPut(networkConnectionId: number, updateNetworkConnectionInput?: UpdateNetworkConnectionInput, options?: AxiosRequestConfig) {
        return NetworkConnectionsApiFp(this.configuration).apiNetworkconnectionsNetworkConnectionIdPut(networkConnectionId, updateNetworkConnectionInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateNetworkConnectionInput} [createNetworkConnectionInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkConnectionsApi
     */
    public apiNetworkconnectionsPost(createNetworkConnectionInput?: CreateNetworkConnectionInput, options?: AxiosRequestConfig) {
        return NetworkConnectionsApiFp(this.configuration).apiNetworkconnectionsPost(createNetworkConnectionInput, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NetworkGatewaysApi - axios parameter creator
 * @export
 */
export const NetworkGatewaysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNetworkgatewaysGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/networkgateways`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} networkGatewayId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNetworkgatewaysNetworkGatewayIdDelete: async (networkGatewayId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'networkGatewayId' is not null or undefined
            assertParamExists('apiNetworkgatewaysNetworkGatewayIdDelete', 'networkGatewayId', networkGatewayId)
            const localVarPath = `/api/networkgateways/{networkGatewayId}`
                .replace(`{${"networkGatewayId"}}`, encodeURIComponent(String(networkGatewayId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} networkGatewayId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNetworkgatewaysNetworkGatewayIdGet: async (networkGatewayId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'networkGatewayId' is not null or undefined
            assertParamExists('apiNetworkgatewaysNetworkGatewayIdGet', 'networkGatewayId', networkGatewayId)
            const localVarPath = `/api/networkgateways/{networkGatewayId}`
                .replace(`{${"networkGatewayId"}}`, encodeURIComponent(String(networkGatewayId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} networkGatewayId 
         * @param {UpdateNetworkGatewayInput} [updateNetworkGatewayInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNetworkgatewaysNetworkGatewayIdPut: async (networkGatewayId: number, updateNetworkGatewayInput?: UpdateNetworkGatewayInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'networkGatewayId' is not null or undefined
            assertParamExists('apiNetworkgatewaysNetworkGatewayIdPut', 'networkGatewayId', networkGatewayId)
            const localVarPath = `/api/networkgateways/{networkGatewayId}`
                .replace(`{${"networkGatewayId"}}`, encodeURIComponent(String(networkGatewayId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNetworkGatewayInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateNetworkGatewayInput} [createNetworkGatewayInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNetworkgatewaysPost: async (createNetworkGatewayInput?: CreateNetworkGatewayInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/networkgateways`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNetworkGatewayInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NetworkGatewaysApi - functional programming interface
 * @export
 */
export const NetworkGatewaysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NetworkGatewaysApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNetworkgatewaysGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NetworkGatewayResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNetworkgatewaysGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} networkGatewayId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNetworkgatewaysNetworkGatewayIdDelete(networkGatewayId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNetworkgatewaysNetworkGatewayIdDelete(networkGatewayId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} networkGatewayId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNetworkgatewaysNetworkGatewayIdGet(networkGatewayId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NetworkGatewayResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNetworkgatewaysNetworkGatewayIdGet(networkGatewayId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} networkGatewayId 
         * @param {UpdateNetworkGatewayInput} [updateNetworkGatewayInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNetworkgatewaysNetworkGatewayIdPut(networkGatewayId: number, updateNetworkGatewayInput?: UpdateNetworkGatewayInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNetworkgatewaysNetworkGatewayIdPut(networkGatewayId, updateNetworkGatewayInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateNetworkGatewayInput} [createNetworkGatewayInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNetworkgatewaysPost(createNetworkGatewayInput?: CreateNetworkGatewayInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNetworkgatewaysPost(createNetworkGatewayInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NetworkGatewaysApi - factory interface
 * @export
 */
export const NetworkGatewaysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NetworkGatewaysApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNetworkgatewaysGet(options?: any): AxiosPromise<Array<NetworkGatewayResponseDto>> {
            return localVarFp.apiNetworkgatewaysGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} networkGatewayId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNetworkgatewaysNetworkGatewayIdDelete(networkGatewayId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiNetworkgatewaysNetworkGatewayIdDelete(networkGatewayId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} networkGatewayId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNetworkgatewaysNetworkGatewayIdGet(networkGatewayId: number, options?: any): AxiosPromise<NetworkGatewayResponseDto> {
            return localVarFp.apiNetworkgatewaysNetworkGatewayIdGet(networkGatewayId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} networkGatewayId 
         * @param {UpdateNetworkGatewayInput} [updateNetworkGatewayInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNetworkgatewaysNetworkGatewayIdPut(networkGatewayId: number, updateNetworkGatewayInput?: UpdateNetworkGatewayInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiNetworkgatewaysNetworkGatewayIdPut(networkGatewayId, updateNetworkGatewayInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateNetworkGatewayInput} [createNetworkGatewayInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNetworkgatewaysPost(createNetworkGatewayInput?: CreateNetworkGatewayInput, options?: any): AxiosPromise<number> {
            return localVarFp.apiNetworkgatewaysPost(createNetworkGatewayInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NetworkGatewaysApi - object-oriented interface
 * @export
 * @class NetworkGatewaysApi
 * @extends {BaseAPI}
 */
export class NetworkGatewaysApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkGatewaysApi
     */
    public apiNetworkgatewaysGet(options?: AxiosRequestConfig) {
        return NetworkGatewaysApiFp(this.configuration).apiNetworkgatewaysGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} networkGatewayId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkGatewaysApi
     */
    public apiNetworkgatewaysNetworkGatewayIdDelete(networkGatewayId: number, options?: AxiosRequestConfig) {
        return NetworkGatewaysApiFp(this.configuration).apiNetworkgatewaysNetworkGatewayIdDelete(networkGatewayId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} networkGatewayId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkGatewaysApi
     */
    public apiNetworkgatewaysNetworkGatewayIdGet(networkGatewayId: number, options?: AxiosRequestConfig) {
        return NetworkGatewaysApiFp(this.configuration).apiNetworkgatewaysNetworkGatewayIdGet(networkGatewayId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} networkGatewayId 
     * @param {UpdateNetworkGatewayInput} [updateNetworkGatewayInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkGatewaysApi
     */
    public apiNetworkgatewaysNetworkGatewayIdPut(networkGatewayId: number, updateNetworkGatewayInput?: UpdateNetworkGatewayInput, options?: AxiosRequestConfig) {
        return NetworkGatewaysApiFp(this.configuration).apiNetworkgatewaysNetworkGatewayIdPut(networkGatewayId, updateNetworkGatewayInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateNetworkGatewayInput} [createNetworkGatewayInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkGatewaysApi
     */
    public apiNetworkgatewaysPost(createNetworkGatewayInput?: CreateNetworkGatewayInput, options?: AxiosRequestConfig) {
        return NetworkGatewaysApiFp(this.configuration).apiNetworkgatewaysPost(createNetworkGatewayInput, options).then((request) => request(this.axios, this.basePath));
    }
}


